/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Buy it Now functionality
document.addEventListener('DOMContentLoaded', function() {
  // Handle Buy it Now button clicks
  document.addEventListener('click', function(event) {
    if (event.target.matches('[data-action="buy-now"]')) {
      event.preventDefault();
      
      const button = event.target;
      const productId = button.getAttribute('data-product-id');
      const productUrl = button.getAttribute('data-product-url');
      
      if (!productId) {
        console.error('Product ID not found for Buy it Now button');
        return;
      }
      
      // Show loading state
      const originalText = button.textContent;
      button.textContent = 'Adding...';
      button.disabled = true;
      
      // Add product to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // Trigger cart refresh event
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        
        // Redirect to checkout
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
        
        // Reset button state
        button.textContent = originalText;
        button.disabled = false;
        
        // Show error message (you can customize this)
        alert('Sorry, there was an error adding the product to your cart. Please try again.');
      });
    }
  });
  
  // Hide sticky search bar on scroll
  let lastScrollTop = 0;
  const searchBarWrapper = document.querySelector('.header__search-bar-wrapper');
  const searchInput = document.querySelector('.search-bar__input');
  
  // Function to close search drawer
  function closeSearchDrawer() {
    if (!searchBarWrapper) return;
    
    // Remove the fixed class to hide the sticky search bar
    searchBarWrapper.classList.remove('is-fixed');
    
    // Remove expanded state
    const searchBar = searchBarWrapper.querySelector('.search-bar');
    if (searchBar) {
      searchBar.classList.remove('is-expanded');
    }
    
    // Blur the input (but DON'T remove is-filled yet)
    if (searchInput) {
      searchInput.blur();
    }
    
    // Re-enable body scroll
    document.body.classList.remove('no-mobile-scroll');
    
    // Hide search results
    const searchResults = searchBarWrapper.querySelector('.search-bar__results');
    if (searchResults) {
      searchResults.setAttribute('aria-hidden', 'true');
    }
    
    // Hide search menu
    const searchMenu = searchBarWrapper.querySelector('.search-bar__menu-wrapper');
    if (searchMenu) {
      searchMenu.setAttribute('aria-hidden', 'true');
    }
  }
  
  if (searchBarWrapper) {
    // Close search drawer on MAIN PAGE scroll (not drawer scroll)
    let isScrollingInsideDrawer = false;
    
    // Track when scrolling inside drawer
    const searchInner = searchBarWrapper.querySelector('.search-bar__inner');
    const searchResults = searchBarWrapper.querySelector('.search-bar__results');
    
    if (searchInner) {
      searchInner.addEventListener('scroll', function() {
        isScrollingInsideDrawer = true;
        setTimeout(() => { isScrollingInsideDrawer = false; }, 100);
      }, { passive: true });
    }
    
    if (searchResults) {
      searchResults.addEventListener('scroll', function() {
        isScrollingInsideDrawer = true;
        setTimeout(() => { isScrollingInsideDrawer = false; }, 100);
      }, { passive: true });
    }
    
    // Close drawer only on main window/body scroll
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      
      // Check if search bar is fixed/sticky and user is scrolling OUTSIDE drawer
      if (searchBarWrapper.classList.contains('is-fixed') && !isScrollingInsideDrawer) {
        closeSearchDrawer();
      }
      
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    }, false);
    
    // Handle clear button click - Let theme.js handle the clearing, we just close drawer
    const clearButton = document.querySelector('.search-bar__input-clear');
    if (clearButton) {
      clearButton.addEventListener('click', function(e) {
        // Wait a tiny bit for theme.js to clear the input
        setTimeout(function() {
          closeSearchDrawer();
        }, 50);
      });
    }
  }
  
  // Prevent scroll to top when adding to cart
  let currentScrollPosition = 0;
  let preventScrollFlag = false;
  
  // Store the current scroll position before any potential scroll
  window.addEventListener('scroll', function() {
    if (!preventScrollFlag) {
      currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    }
  }, { passive: true });
  
  // Override window.scrollTo to prevent unwanted scrolling
  const originalScrollTo = window.scrollTo;
  window.scrollTo = function(...args) {
    if (preventScrollFlag) {
      const isScrollingToTop = (typeof args[0] === 'object' && args[0] && args[0].top === 0) || 
                                (typeof args[0] === 'number' && args[0] === 0 && args[1] === 0) ||
                                (args[0] === 0 && args.length === 1);
      
      if (isScrollingToTop) {
        console.log('Prevented scroll to top');
        return;
      }
    }
    originalScrollTo.apply(window, args);
  };
  
  // Function to update all cart counts
  function updateAllCartCounts() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update header cart count
        const headerCartCount = document.querySelector('.header__cart-count');
        if (headerCartCount) {
          headerCartCount.textContent = cart.item_count;
        }
        
        // Update mobile bottom nav cart count
        const mobileCartCount = document.getElementById('mobile-cart-count');
        if (mobileCartCount) {
          mobileCartCount.textContent = cart.item_count;
          console.log('Mobile cart count updated to:', cart.item_count);
        }
        
        // Update any other cart count elements
        const allCartCounts = document.querySelectorAll('.cart-count');
        allCartCounts.forEach(element => {
          if (element.id !== 'mobile-cart-count') {
            element.textContent = cart.item_count;
          }
        });
        
        return cart;
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
  }
  
  // Listen to product:added event
  document.addEventListener('product:added', function(event) {
    console.log('Product added to cart');
    
    // Store current scroll position
    currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    // Prevent scroll to top for next 1 second
    preventScrollFlag = true;
    
    // Update cart count immediately
    updateAllCartCounts();
    
    // Restore scroll position if it changed
    setTimeout(() => {
      const newScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (newScrollPosition !== currentScrollPosition) {
        window.scroll({
          top: currentScrollPosition,
          behavior: 'instant'
        });
      }
      preventScrollFlag = false;
    }, 1000);
  });
  
  // Also listen to cart:refresh event
  document.addEventListener('cart:refresh', function(event) {
    console.log('Cart refresh triggered');
    updateAllCartCounts();
  });
});

